var React = require('react');

function UserSlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M192.47 117a128 128 0 1 1 170.32 131.66zM96 422.4V464a48 48 0 0 0 48 48h350.2L207.37 290.3C144.17 301.3 96 356 96 422.4z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M636.67 480.4l-19.6 25.3a16.06 16.06 0 0 1-22.5 2.8L6.17 53.8a15.93 15.93 0 0 1-2.8-22.4L23 6.2a16.06 16.06 0 0 1 22.5-2.8l588.3 454.7a15.85 15.85 0 0 1 2.87 22.3z","className":"fa-primary","key":2})]);
}

UserSlash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = UserSlash;

UserSlash.default = UserSlash;
